import React from 'react';
import { LeaseFile, ShieldInformation, ShieldStatus } from 'App/ServiceContinuity';

export interface IServiceContinuityContext {
	shieldInformation: ShieldInformation;
	leaseFiles: LeaseFile[];
	shieldStatus: ShieldStatus;
	isLoading: boolean;
	lastClientResyncTriggerTime: Date | null;
	syncPlatformLeaseInformation: () => Promise<void>;
	initializeLeaseSync: () => Promise<string>;
	initializeLogCollection: () => void | undefined;
}

export const defaultContext: IServiceContinuityContext = {
	shieldInformation: {} as ShieldInformation,
	leaseFiles: [],
	shieldStatus: {
		lastCLSyncStatus: undefined as any,
		lastLeaseSyncSuccessTime: '',
		expiredLeases: [],
		expiringLeases: [],
		activeLeases: [],
		missingLeases: [],
	},
	isLoading: false,
	lastClientResyncTriggerTime: null,
	syncPlatformLeaseInformation: async () => {},
	initializeLeaseSync: async () => '',
	initializeLogCollection: () => undefined,
};

export const ServiceContinuityContext =
	React.createContext<IServiceContinuityContext>(defaultContext);
export const useServiceContinuityContext = () =>
	React.useContext(ServiceContinuityContext);
